import { render, staticRenderFns } from "./Benchmark.vue?vue&type=template&id=3ff59eff&scoped=true&"
import script from "./Benchmark.vue?vue&type=script&lang=js&"
export * from "./Benchmark.vue?vue&type=script&lang=js&"
import style0 from "./Benchmark.vue?vue&type=style&index=0&id=3ff59eff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff59eff",
  null
  
)

export default component.exports